const colors = {
  white: '#FFF',
  color1: '#F9F8FD',
  error1: '#FF005C',
  error2: '#D40202',
  gray1: '#2A2934',
  gray2: '#3E3C4C',
  gray3: '#8F9097',
  gray4: '#CCCED2',
  gray5: '#EBEBEB',
  gray6: '#D0D1D3',
  gray7: '#F5F5F6',
  green1: '#2ECAAF',
  green2: '#24A08A',
  green3: '#2EFFAF',
  green4: '#92E0D4',
  green5: '#CDEEEB',
  color3: '#FDCD05',
  color4: '#22B9C7',
  color5: '#E80C7A',
  color6: '#8123B3',
  color8: '#716C94',
  color9: '#BF3D80',
  color10: '#72C0D4',
  color11: '#FA9C82',
  color12: '#F2B3B3',
  color13: '#FEF0B4',

  // non-conformant colors
  'color-c81717': '#c81717',
  'color-ee162d': '#EE162D',
  'color-f5f7fa': '#F5F7FA',
  'color-e5e5e5': '#E5E5E5',
  'color-0568fd': '#0568FD',
  'color-eeeeee': '#EEEEEE',

  'color-757575': '#757575',
  'color-dadada': '#DADADA',
  gray8: '#C4C4C4',
  e0e0e0: '#e0e0e0',
  tableRow: '#f2f2f2',
  menuGreenDividers: 'rgba(46, 202, 175, 0.2)',
};

export { colors };
